"use es6";

import { createContext } from 'react';
const LazyContext = /*#__PURE__*/createContext({
  strict: false
});
export { LazyContext };